export function getURLQuery(param, url = location.href) {
  if (!param) return;
  param = param.replace(/[\[\]]/g, '\\$&');

  const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function fromShopCampaign(state) {
  // const query = state.urlquery.shopcampaign
  // return getURLQuery(query.key) === query.value

  const EC_VAL = fromEC(state)
  if(EC_VAL === 0) return '1'
  else return ''
}

export function fromEC(state) {
  const query = state.urlquery.ec
  const value = Number(getURLQuery(query.key))
  const valueArr = query.value.split(",")
  let prm = 0
  for(let i = 0; i < valueArr.length; i++) {
    const v = Number(valueArr[i])
    if(v === value) {
      prm = value
      break
    }
  }
  return prm
}

